import { render, staticRenderFns } from "./ItemsGridDescription.vue?vue&type=template&id=f8fc36dc&"
import script from "./ItemsGridDescription.vue?vue&type=script&lang=js&"
export * from "./ItemsGridDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports